import Vue from "vue";
import Pagination from "./Pagination.vue";
import EmptyState from "./EmptyState.vue";

Vue.component("Pagination", Pagination);
Vue.component("EmptyState", EmptyState);
